import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useNotify from "hooks/useNotify";
import { actions } from "store/actions";
import profileApi from "api/profile";
import { scrollIntoView } from "utils/helper";
import { resumeType } from "utils/constantValues";

function UseCvInformation() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isLoading, setIsLoading] = useState(false);
  const [isEditProfileResume, setIsEditProfileResume] = useState(false);
  const [fileName, setFileName] = useState("");

  const { notifyError, notifySuccess } = useNotify();

  const onEditResume = async (values) => {
    try {
      setIsLoading(true);

      const resumeId = values.resume?.id ?? values.resume;
      await profileApi.updateVendorResume(userDetails?.vendorId, { resumeId });

      const filteredResumeFile = userDetails?.userFiles?.filter(
        (file) => file.type !== resumeType
      );

      let oldResume = userDetails?.userFiles?.find(
        (file) => file.type === resumeType
      );

      if (!oldResume) {
        // the user doesn't have a resume yet, so in this case we need to invoke the userDetails
        //example, when the vm create a freelancer from vm
        dispatch(actions.fetchUserDetails(userDetails.id));
      } else if (values?.resume?.name) {
        dispatch(
          actions.setUserDetails({
            ...userDetails,
            userFiles: [
              ...filteredResumeFile,
              { ...values.resume, id: oldResume.id },
            ],
          })
        );
      } else {
        dispatch(
          actions.setUserDetails({
            ...userDetails,
            userFiles: [...filteredResumeFile],
          })
        );
      }

      setIsEditProfileResume(false);
      notifySuccess("Has been updated successfully");
      scrollIntoView("resumeScrollId");
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  const resetOnUnmount = () => {};
  useEffect(() => {
    return () => {
      resetOnUnmount();
    };
  }, []);
  return {
    isLoading,
    isEditProfileResume,
    onEditResume,
    fileName,
    setFileName,
  };
}

export default UseCvInformation;
